import React, { useEffect, useState, useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../../store';
import {
  completeTransition,
  failTransition,
} from '../../store/slices/stageSlice';
import CelebrationModal from './CelebrationModal';

const StageTransitionManager: React.FC = () => {
  const { pendingTransition, isTransitioning } = useAppSelector(
    state => state.stage
  );
  const dispatch = useAppDispatch();

  const [showCelebration, setShowCelebration] = useState(false);
  const [transitionData, setTransitionData] = useState<any>(null);

  const handleStageTransition = useCallback(
    async (transition: any) => {
      try {
        setTransitionData(transition);
        setShowCelebration(true);

        await new Promise(resolve => setTimeout(resolve, 2000));

        dispatch(completeTransition(transition));

        setTimeout(() => {
          setShowCelebration(false);
          setTransitionData(null);
        }, 3000);
      } catch (error) {
        dispatch(
          failTransition({
            transition,
            error: error instanceof Error ? error.message : '阶段切换失败',
          })
        );

        setShowCelebration(false);
        setTransitionData(null);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (pendingTransition && isTransitioning) {
      handleStageTransition(pendingTransition);
    }
  }, [pendingTransition, isTransitioning, handleStageTransition]);

  if (!showCelebration || !transitionData) {
    return null;
  }

  return (
    <CelebrationModal
      fromStage={transitionData.from}
      toStage={transitionData.to}
      achievements={transitionData.achievements || []}
      nextSteps={transitionData.nextSteps || []}
      onClose={() => setShowCelebration(false)}
    />
  );
};

export default StageTransitionManager;
